import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    public currentLang: string;
    public notyArray: any;

    constructor(public translate: TranslateService, private toastr: ToastrService) {
        this.notyArray = [];
    }

    basicNoty(type: string = 'ERROR', message: string = 'Sorry, something went wrong', title: string = type) {
        if (this.translate.currentLang == undefined) {
            this.currentLang = this.translate.defaultLang;
        } else {
            this.currentLang = this.translate.currentLang;
        }
        type === 'ERROR'
            ? this.toastr.error(message, title, {timeOut: 3000, closeButton: true, progressBar: true})
            : type === 'WARNING'
            ? this.toastr.warning(message, title, {timeOut: 3000, closeButton: true, progressBar: true})
            : this.toastr.success(message, title, {timeOut: 3000, closeButton: true, progressBar: true});
    }
}
